import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import { urlSafeDate } from '@eluve/date-utils';
import { useSession } from '@eluve/session-helpers';

export interface AppIndexPageProps {}

export const AppIndexPage: React.FC<AppIndexPageProps> = () => {
  const session = useSession();
  const [searchParams] = useSearchParams();

  const {
    isEluveAdmin,
    allowedTenantIds,
    'https://hasura.io/jwt/claims': claims,
  } = session!;
  const tenantId = claims['x-hasura-tenant-id'];

  // If the session is already scoped to a specific tenant redirect to their home page
  const queryParams = [`date=${urlSafeDate()}`, searchParams.toString()]
    .filter(Boolean)
    .join('&');
  if (tenantId) {
    return <Navigate to={`organizations/${tenantId}/home?${queryParams}`} />;
  }

  if (!isEluveAdmin) {
    // If its a regular user and they are a member of only a single tenant redirect to their home page
    if (allowedTenantIds.length === 1) {
      return (
        <Navigate
          to={`organizations/${allowedTenantIds[0]}/home?${queryParams}`}
        />
      );
    }

    // If they have access to multiple tenants redirect to the tenant selection page
    return <Navigate to="/organization/switch" />;
  }

  return <div>Placeholder</div>;
};
